// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__anyH8","header":"ReportDetails_header__3Igpm","title":"ReportDetails_title__22WN3","left":"ReportDetails_left__2m97Y"};